import React from "react";
export const OverviewTable = (props) => {
    return React.createElement("div", null, props.children);
};
